if (!customElements.get('site-header')) {
  customElements.define(
    'site-header',
    class SiteHeader extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialised === 'true') {
          document.addEventListener('pointerdown', this.handleDocumentPointer);
          document.addEventListener('keydown', this.handleDocumentKey);
          this.desktopQuery?.addEventListener('change', this.handleDesktopChange);
          if (!document.body?.classList.contains('template-index')) {
            window.addEventListener('scroll', this.onScroll, { passive: true });
            this.onScroll();
          }
          return;
        }
        this.dataset.initialised = 'true';
        this.dialog = this.querySelector('[data-mobile-menu]');
        this.openButton = this.querySelector('[data-mobile-menu-open]');
        this.closeButton = this.querySelector('[data-mobile-menu-close]');
        this.desktopQuery = window.matchMedia('(min-width: 72rem)');
        this.onScroll = this.onScroll.bind(this);
        this.handleDesktopChange = (event) => {
          if (event.matches && this.dialog?.open) this.closeMenu(false);
        };
        this.condensed = null;

        if (this.dialog && this.openButton && this.closeButton) {
          this.openButton.addEventListener('click', () => this.openMenu());
          this.closeButton.addEventListener('click', () => this.closeMenu());
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.closeMenu();
          });
          this.dialog.addEventListener('close', () => this.afterClose());
          this.desktopQuery.addEventListener('change', this.handleDesktopChange);
        }

        this.querySelectorAll('[data-mobile-nav-back]').forEach((button) => {
          button.addEventListener('click', () => {
            const disclosure = button.closest('details');
            if (!disclosure) return;
            disclosure.removeAttribute('open');
            disclosure.querySelector(':scope > summary')?.focus();
          });
        });

        this.desktopDisclosures = [...this.querySelectorAll('[data-desktop-disclosure]')];
        this.desktopDisclosures.forEach((disclosure) => {
          disclosure.addEventListener('toggle', () => {
            if (!disclosure.open) return;
            this.desktopDisclosures.forEach((other) => {
              if (other !== disclosure) other.removeAttribute('open');
            });
          });
        });
        this.handleDocumentPointer = (event) => {
          if (this.contains(event.target)) return;
          this.closeDesktopMenus();
        };
        this.handleDocumentKey = (event) => {
          if (event.key !== 'Escape') return;
          const openDisclosure = this.desktopDisclosures.find((item) => item.open);
          if (!openDisclosure) return;
          openDisclosure.removeAttribute('open');
          openDisclosure.querySelector('summary')?.focus();
        };
        document.addEventListener('pointerdown', this.handleDocumentPointer);
        document.addEventListener('keydown', this.handleDocumentKey);

        // The homepage header is deliberately fixed by its production CSS and never condenses.
        if (!document.body?.classList.contains('template-index')) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('pointerdown', this.handleDocumentPointer);
        document.removeEventListener('keydown', this.handleDocumentKey);
        this.desktopQuery?.removeEventListener('change', this.handleDesktopChange);
      }

      closeDesktopMenus() {
        this.desktopDisclosures?.forEach((item) => item.removeAttribute('open'));
      }

      onScroll() {
        const condensed = window.scrollY > 120;
        if (this.condensed === condensed) return;
        this.condensed = condensed;
        this.classList.toggle('is-condensed', condensed);
      }

      openMenu() {
        this.previouslyFocused = document.activeElement;
        this.openButton?.setAttribute('aria-expanded', 'true');
        if (typeof this.dialog?.showModal === 'function') this.dialog.showModal();
        else this.dialog?.setAttribute('open', '');
        this.closeButton?.focus();
      }

      closeMenu(restoreFocus = true) {
        this.restoreFocus = restoreFocus;
        if (typeof this.dialog?.close === 'function') this.dialog.close();
        else {
          this.dialog?.removeAttribute('open');
          this.afterClose();
        }
      }

      afterClose() {
        this.openButton?.setAttribute('aria-expanded', 'false');
        if (this.restoreFocus !== false && this.previouslyFocused instanceof HTMLElement) {
          this.previouslyFocused.focus();
        }
        this.restoreFocus = true;
      }
    }
  );
}
